"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Snooze: function() {
        return Snooze;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const Snooze = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M8.00002 2C8.00002 1.44772 8.44773 1 9.00002 1H14C14.388 1 14.741 1.22446 14.9056 1.57584C15.0702 1.92723 15.0166 2.3421 14.7682 2.64018L11.1351 7H14C14.5523 7 15 7.44772 15 8C15 8.55228 14.5523 9 14 9H9.00002C8.612 9 8.25901 8.77554 8.09443 8.42416C7.92985 8.07277 7.98339 7.6579 8.2318 7.35982L11.865 3H9.00002C8.44773 3 8.00002 2.55228 8.00002 2ZM16 12C16 11.4477 16.4477 11 17 11H22C22.388 11 22.741 11.2245 22.9056 11.5758C23.0702 11.9272 23.0166 12.3421 22.7682 12.6402L19.1351 17H22C22.5523 17 23 17.4477 23 18C23 18.5523 22.5523 19 22 19H17C16.612 19 16.259 18.7755 16.0944 18.4242C15.9298 18.0728 15.9834 17.6579 16.2318 17.3598L19.865 13H17C16.4477 13 16 12.5523 16 12ZM1.00002 13C1.00002 12.4477 1.44773 12 2.00002 12H10C10.3938 12 10.7509 12.2311 10.9123 12.5903C11.0736 12.9496 11.009 13.37 10.7474 13.6644L4.22686 21H10C10.5523 21 11 21.4477 11 22C11 22.5523 10.5523 23 10 23H2.00002C1.60623 23 1.2491 22.7689 1.08778 22.4097C0.926458 22.0504 0.990987 21.63 1.25261 21.3356L7.77317 14H2.00002C1.44773 14 1.00002 13.5523 1.00002 13Z",
        fill: "currentColor"
    })
}), "Snooze");
const _default = Snooze;
